import React, { useState } from "react";
import NetaqInput from "./NetaqInput";
import { useTranslate } from "./TranslationText";
import NewActionButton from "./ActionButtons/NewActionButton";
import { filterButtonsContainer, filterCard, filterHeader, filterResetBtn, filterSubmitBtn } from "../common/cssclasses";

// Flutter API filter keys: title, category (e.g. "Genetic diseases" / null), dateFrom (yyyy-MM-dd), dateTo (yyyy-MM-dd)

const initFilterState = {
  coursTitle: "",       // → API key: title
  coursecategory: "",   // → API key: category (empty = All, null handled in handler)
  DateFrom: "",
  DateTo: "",
};

const EducationalFilter = ({ onSubmit, categoriesList = [] }) => {
  const { translate } = useTranslate();
  const [dateStartFrom, setDateStartFrom] = useState(null);
  const [dateStartTo, setDateStartTo] = useState(null);
  const [filterState, setFilterState] = useState(initFilterState);

  const handleChange = (event, input) => {
    if (input === "DateFrom") {
      setDateStartFrom(event);
      setFilterState(prev => ({
        ...prev,
        DateFrom: event && event.toDate ? event.toDate() : "",
      }));
      return;
    }
    if (input === "DateTo") {
      setDateStartTo(event);
      setFilterState(prev => ({
        ...prev,
        DateTo: event && event.toDate ? event.toDate() : "",
      }));
      return;
    }
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setFilterState(prev => ({ ...prev, [event.target.name]: value }));
  };

  const handleSubmit = (event) => {
    window.scrollTo(0, 0);
    event.preventDefault();
    onSubmit(filterState);
  };

  const handleReset = () => {
    window.scrollTo(0, 0);
    setDateStartFrom(null);
    setDateStartTo(null);
    const cleared = { ...initFilterState };
    setFilterState(cleared);
    onSubmit(cleared); // ← IMPORTANT: trigger re-fetch with empty filters
  };

  return (
    <form className={filterCard} onSubmit={handleSubmit} onReset={handleReset}>
      <h2 className={filterHeader}>{translate('web.simplesearch', 'Search')}</h2>

      {/* Title */}
      <div className="mb-form-group">
        <NetaqInput
          name="coursTitle"
          label={translate("web.courseTitle", "Course Title")}
          placeholder={translate("web.courseTitle", "Course Title")}
          type="text"
          onChange={handleChange}
          value={filterState.coursTitle}
        />
      </div>

      {/* Category — radio buttons from dynamic list */}
      <div className="mb-form-group">
        <label>{translate("web.courseCategory", "Course Category")}</label>
        <div className="AuctionFilterRadioContainer">
          {categoriesList.map((cat) => (
            <NetaqInput
              key={cat}
              name="coursecategory"
              type="radio"
              value={cat}
              checked={filterState.coursecategory === cat}
              label={cat}
              onChange={handleChange}
            />
          ))}
          {/* "All" clears the filter → empty string */}
          <NetaqInput
            name="coursecategory"
            type="radio"
            value=""
            checked={filterState.coursecategory === ""}
            label={translate("web.all", "All")}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* Date Range */}
      <div className="row mb-form-group-last">
        <div className="col-6">
          <NetaqInput
            name="DateFrom"
            type="date"
            label={<>{translate("web.date", "Date")} {translate("web.from", "From")}</>}
            onChange={handleChange}
            value={dateStartFrom}
          />
        </div>
        <div className="col-6">
          <NetaqInput
            name="DateTo"
            type="date"
            label={<>{translate("web.date", "Date")} {translate("web.to", "To")}</>}
            onChange={handleChange}
            value={dateStartTo}
            minDate={dateStartFrom}
          />
        </div>
      </div>

      <div className={filterButtonsContainer}>
        <div className={filterResetBtn}>
          <NewActionButton
            isButton
            classNames="btn-outline-secondary"
            type="reset"
            text={translate('web.reset', 'Reset')}
          />
        </div>
        <div className={filterSubmitBtn}>
          <NewActionButton
            isButton
            classNames="btn-danger"
            text={translate("web.search", "Search")}
            type="submit"
          />
        </div>
      </div>
    </form>
  );
};

export default EducationalFilter;
